import { StatTableColumnBase } from "../../StatTableColumn";

export const DEFAULT_FRACTION_DIGITS = 1;

export type StatTableNumberColumn<T> = StatTableColumnBase & {
  valueGetter: (arg: T) => number | undefined;
  subTextGetter?: (arg: T) => string | undefined;
  fractionDigits?: number;
  showPositiveSign?: boolean;
  type: "Number";
};
